/**
 * Bottom tabs.
 *
 * Two destinations only — playing and money. Resisting a third ("Profile",
 * "History") is deliberate: history lives inside the wallet where the balance
 * it explains is, and everything a profile would show is either in Telegram
 * already or is one setting that fits beside the language toggle.
 *
 * Hidden inside a round, because that screen owns the full height and a player
 * watching balls does not need a way to wander off mid-game.
 */

import { useT } from '../i18n/index.tsx';
import { haptics } from '../telegram.ts';

export type Tab = 'play' | 'wallet';

interface NavProps {
  active: Tab;
  onChange(tab: Tab): void;
}

export function Nav({ active, onChange }: NavProps) {
  const t = useT();

  const tabs: Array<{ id: Tab; label: string; glyph: string }> = [
    { id: 'play', label: t.navRounds, glyph: '◎' },
    { id: 'wallet', label: t.navWallet, glyph: '▤' },
  ];

  return (
    <nav className="nav" aria-label="Main">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={`nav__tab${tab.id === active ? ' nav__tab--on' : ''}`}
          aria-current={tab.id === active ? 'page' : undefined}
          onClick={() => {
            if (tab.id !== active) haptics.tap();
            onChange(tab.id);
          }}
        >
          <span className="nav__glyph" aria-hidden="true">
            {tab.glyph}
          </span>
          <span className="nav__label">{tab.label}</span>
        </button>
      ))}
    </nav>
  );
}
